import { create } from 'zustand';

interface DrawerState {
    isDrawerOpen: boolean;
    setIsDrawerOpen: (open: boolean) => void;
}

// Create the Zustand store with types
const useStore = create<DrawerState>((set) => ({
    isDrawerOpen: false,
    setIsDrawerOpen: (open: boolean) => set({ isDrawerOpen: open }),
}));

export default useStore;
